// eslint-disable-next-line import/no-anonymous-default-export
export default (property: string[] | string) => Array.isArray(property) ? property.join(',') : property
